import React, { FC } from 'react';

import { VbzButton } from '@smiles/voebiz-ui-kit';
import { ModalBody } from 'reactstrap';

interface SuccessProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: any;
  previousTier?: string;
  tier?: string;
}

const ModalDowngradeBody: FC<SuccessProps> = ({ onClick, previousTier, tier }) => (
  <ModalBody>
    <div className="smls-modal-header">
      {previousTier && <h4>Sua empresa agora faz parte da categoria {previousTier}</h4>}
    </div>

    <p>
      Dessa vez, sua empresa não atingiu os valores necessários para se manter na categoria {tier}.
      <br />
      <br />
      Agora sua empresa faz parte da categoria {previousTier} e já pode aproveitar os benefícios.
    </p>

    {/* <SmlsButton */}
    <VbzButton id="submit" className="vbz-update-modal-btn" text="Acessar benefícios" onClick={onClick} />
  </ModalBody>
);

ModalDowngradeBody.defaultProps = {
  previousTier: undefined,
  tier: undefined,
};

export default ModalDowngradeBody;
